import {solutionTypes} from "../shared/common/constants";
import moment from 'moment';
import store from '../../store';


export default class SearchResultsSorter {

    public static sortFares(faresPages: Array<any>, solutionType: number, flexibleDates: boolean) {
        switch (solutionType) {
            case solutionTypes.bestValue:
                for (let legIndex = 0; legIndex < faresPages.length; legIndex++) {
                    if (flexibleDates) {
                        const trips = store.state.trips;
                        let onDate: Array<any> = [];
                        let altDate: Array<any> = [];
                        faresPages[legIndex].forEach((fare: any) => {
                            if (fare.segments[0].departure_date.substring(4) === trips[legIndex].date) {
                                onDate.push(fare);
                            } else {
                                altDate.push(fare);
                            }
                        });
                        onDate.sort(this.sortByStopsDurationDeparture);
                        altDate.sort(this.sortByStopsDurationDeparture);
                        faresPages[legIndex] = onDate.concat(altDate);
                    } else {
                        faresPages[legIndex].sort(this.sortByStopsDurationDeparture);
                    }
                }
                break;
            case solutionTypes.fewestStops:
                for (let i = 0; i < faresPages.length; i++) {
                    faresPages[i].sort(this.sortByStopsDurationDeparture);
                }
                break;
            case solutionTypes.bestTime:
                for (let i = 0; i < faresPages.length; i++) {
                    faresPages[i].sort(this.sortByDurationStopsDeparture);
                }
                break;
            case solutionTypes.bestPrice:
                for (let i = 0; i < faresPages.length; i++) {
                    faresPages[i].sort(this.sortByDeparture);
                }
                break;
            case solutionTypes.customize:
                for (let i = 0; i < faresPages.length; i++) {
                    faresPages[i].sort(this.sortByPriceAndDuration);
                }
                break;
            default:
                return;
        }
    }

    private static sortByDeparture(a: any, b: any) {
        const departureTimeA = moment(a.segments[0].departure_date + ' ' + a.segments[0].departure_time,
            'DD-MMM-YY HH:mm');
        const departureTimeB = moment(b.segments[0].departure_date + ' ' + b.segments[0].departure_time,
            'DD-MMM-YY HH:mm');
        return departureTimeA >= departureTimeB ? 1 : -1;
    }

    private static sortByStopsDurationDeparture(a: any, b: any) {
        if (a.all_stops > b.all_stops) {
            return 1;
        } else if (a.all_stops < b.all_stops) {
            return -1;
        } else {
            if (SearchResultsSorter.getMinutes(a.all_flights_duration) > SearchResultsSorter.getMinutes(b.all_flights_duration)) {
                return 1;
            } else if (SearchResultsSorter.getMinutes(a.all_flights_duration) < SearchResultsSorter.getMinutes(b.all_flights_duration)) {
                return -1;
            } else {
                return SearchResultsSorter.sortByDeparture(a, b);
            }
        }
    }

    private static sortByDurationStopsDeparture(a: any, b: any) {
        if (SearchResultsSorter.getMinutes(a.all_flights_duration) > SearchResultsSorter.getMinutes(b.all_flights_duration)) {
            return 1;
        } else if (SearchResultsSorter.getMinutes(a.all_flights_duration) < SearchResultsSorter.getMinutes(b.all_flights_duration)) {
            return -1;
        } else {
            if (a.all_stops > b.all_stops) {
                return 1;
            } else if (a.all_stops < b.all_stops) {
                return -1;
            } else {
                return SearchResultsSorter.sortByDeparture(a, b);
            }
        }
    }

    private static getMinutes(durationString: string) {
        let splits = durationString.split(' ');
        return parseInt(splits[0]) * 60 + parseInt(splits[2]);
    }

    private static sortByPriceAndDuration(a: any, b: any) {
        if (SearchResultsSorter.getMinutes(a.all_flights_duration) > SearchResultsSorter.getMinutes(b.all_flights_duration)) {
            return 1;
        } else if (SearchResultsSorter.getMinutes(a.all_flights_duration) < SearchResultsSorter.getMinutes(b.all_flights_duration)) {
            return -1;
        } else {
            return SearchResultsSorter.sortByDeparture(a, b);
        }
    }


}